import { render } from "./NeiItem.vue?vue&type=template&id=4d644afa&scoped=true"
import script from "./NeiItem.vue?vue&type=script&lang=ts"
export * from "./NeiItem.vue?vue&type=script&lang=ts"

import "./NeiItem.vue?vue&type=style&index=0&id=4d644afa&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4d644afa"

export default script